import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../Svg';
const LocateMeIcon = ({ size, ...rest }) => {
    return (_jsx(Svg, { size: size, viewBox: "0 0 24 24", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 10.6933L20 4L13.2978 20H12.4267L10.08 13.92L4 11.5644V10.6933ZM12.817 17.0044L17.0044 7L7 11.1776L10.3875 12.4911L11.1973 12.8071L11.5134 13.6268L12.817 17.0044Z", fill: "currentColor" }) }));
};
export default LocateMeIcon;
//# sourceMappingURL=LocateMeIcon.js.map